import { api } from "./api";
import { customerAgreementsEndPoints } from "../constants/endpoints";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const generateCustomerAgreement = async ({
  customerId,
  payload,
}: {
  customerId: string;
  payload: any;
}) => {
  const endpoint = `${customerAgreementsEndPoints.customerAgreement}/${customerId}`;

  try {
    return await api.post(endpoint, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to generate customer agreement");
  }
};

export const uploadSignedCustomerAgreement = async ({
  customerId,
  payload,
}: {
  customerId: string;
  payload: any;
}) => {
  const endpoint = `${customerAgreementsEndPoints.uploadCustomerAgreement}/${customerId}`;

  try {
    return await api.post(endpoint, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to upload signed customer agreement");
  }
};
